import axios from 'axios'
import { Loading, Notification } from 'element-ui'
import router from '@/router'
import { RESTFUL_HOST } from './host'

/**
 * 拦截器
 */
axios.interceptors.request.use(
  function(config) {
    const token = window.localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    const companyId = localStorage.getItem('curCompanyId')
    if (companyId) {
      config.headers.companyId = companyId
    }
    config.headers.vehicleType = '1'
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.defaults.withCredentials = true
export default {
  get: (url, data) => {
    var _url = url
    if (!url.startsWith('http')) {
      _url = RESTFUL_HOST + url
    }
    // 判断某些请求没有data的情况，如果需要不带loading，就给个参数loading为false
    data = data || { loading: true }
    // 请求时的loading处理，所有的请求都有loading，只有实时数据图表不要loading
    data.loading = data.loading !== false
    return new Promise((resolve, reject) => {
      if (data.loading) {
        var loadingInstance = Loading.service({
          fullscreen: true
        })
      }
      axios
        .get(_url, { params: data })
        .then(response => {
          if (data.loading) {
            loadingInstance.close()
          }

          parseResponse(response.data, resolve, reject)
        })
        .catch(response => {
          if (data.loading) {
            loadingInstance.close()
          }

          parseResponse(
            { code: 'ERROR', message: '网络连接中断，请检查您的网络' },
            null,
            reject
          )
        })
    })
  },
  post: (url, data) => {
    var _url = url
    if (!url.startsWith('http')) {
      _url = RESTFUL_HOST + url
    }
    if (data) {
      // data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      const loadingInstance = Loading.service({
        fullscreen: true
      })

      axios
        .post(_url, data)
        .then(response => {
          loadingInstance.close()
          parseResponse(response.data, resolve, reject)
        })
        .catch(response => {
          loadingInstance.close()
          parseResponse(
            { code: 'ERROR', message: '网络连接中断，请检查您的网络' },
            null,
            reject
          )
        })
    })
  },
  put: (url, data) => {
    var _url = url
    if (!url.startsWith('http')) {
      _url = RESTFUL_HOST + url
    }
    if (data) {
      // data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      const loadingInstance = Loading.service({
        fullscreen: true
      })
      axios
        .put(_url, data)
        .then(response => {
          loadingInstance.close()
          parseResponse(response.data, resolve, reject)
        })
        .catch(response => {
          loadingInstance.close()
          parseResponse(
            { code: 'ERROR', message: '网络连接中断，请检查您的网络' },
            null,
            reject
          )
        })
    })
  },
  delete: (url, data) => {
    var _url = url
    if (!url.startsWith('http')) {
      _url = RESTFUL_HOST + url
    }
    if (data) {
      // data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      const loadingInstance = Loading.service({
        fullscreen: true
      })
      axios
        .delete(_url, { data: data })
        .then(response => {
          loadingInstance.close()
          parseResponse(response.data, resolve, reject)
        })
        .catch(response => {
          loadingInstance.close()
          parseResponse(
            { code: 'ERROR', message: '网络连接中断，请检查您的网络' },
            null,
            reject
          )
        })
    })
  }
}

function parseResponse(resp, resolve, reject) {
  var { code, message, data } = resp
  // 成功
  if (!code || code === 1) {
    return resolve(data)
  }
  if (code === 'TOKEN_ERR') {
    return router.push('/')
  } else if (code === 'DISABLE_ERR') {
    Notification.warning({
      title: '系统提示',
      message: message,
      duration: 2000,
      onClose: () => {
        router.push('/')
      }
    })
    return
  }
  reject(message)
}



// WEBPACK FOOTER //
// ./src/utils/request.js